import { render } from "./SkeletonLoader.vue?vue&type=template&id=17e84e65&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=17e84e65&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e84e65"]])

export default __exports__